import React from 'react';
import { Disclosure } from '@headlessui/react';
import { PlusIcon, MinusIcon } from '../../modules/Icons';
import FaqConvertMarkdownToHtml from '../helpers/FaqConvertMarkdownToHtml';
import { AccordionProps } from '../../types/components/shared/DynamicComponentsTypes';

const Accordion: React.FC<AccordionProps> = ({ items, className }) => {
  return (
    <div className={`flex flex-col mt-8 text-left max-w-[800px] mx-auto ${className}`} cy-test-id="accordion">
      {items.map((item, index) => (
        <Disclosure key={item._uid || index} data-cy="accordion-item">
          {({ open }) => (
            <>
              <Disclosure.Button
                data-cy="accordion-button"
                className={`pb-4 mb-4 text-left ${!open && 'border-b border-gray-800'}`}>
                <div className="flex items-center justify-between">
                  <div className="font-bold text-[18px]">{item.question}</div>
                  {open ? <MinusAndPlusIcon open={open} /> : <MinusAndPlusIcon open={open} />}
                </div>
              </Disclosure.Button>
              <Disclosure.Panel className="text-gray-500" data-cy="accordion-panel">
                <div
                  className="text-gray-500 text-[14px] mb-8"
                  dangerouslySetInnerHTML={{ __html: FaqConvertMarkdownToHtml(item.answer) }}></div>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      ))}
    </div>
  );
};

const MinusAndPlusIcon = ({ open }) =>
  open ? (
    <MinusIcon className="ml-auto" data-cy="minus-icon" />
  ) : (
    <PlusIcon className="ml-auto" data-cy="plus-icon" />
  );

export default Accordion;
